import React, { useState } from 'react';
import cn from 'classnames';
import { Badge, IconButton, TextButton, TextField, Tooltip, Typography } from 'seagull';
import { TrashLiner24 } from 'seagull/icons';
import styles from "./AmendmentChanges.module.scss";
import ChangesApprovalInfoBox from "../ChangesApprovalInfoBox/ChangesApprovalInfoBox";

function AmendmentNote(props) {
  const {
    testid,
    existingNote,
    isUnsaved,
    onNoteChange
  } = props;
  const [note, setNote] = useState(existingNote || '');
  const [addingNote, setAddingNote] = useState(!!existingNote);
  return isUnsaved ? /*#__PURE__*/React.createElement("div", {
    className: styles.note
  }, addingNote ? /*#__PURE__*/React.createElement(TextField, {
    multiline: true,
    label: "Note",
    value: note,
    "data-testid": testid && "".concat(testid, "-note"),
    onChange: e => {
      const newNote = e.target.value;
      setNote(newNote);
      onNoteChange && onNoteChange(newNote);
    }
  }) : /*#__PURE__*/React.createElement(TextButton, {
    underline: "none",
    "data-testid": testid && "".concat(testid, "-add-note"),
    onClick: () => setAddingNote(true)
  }, "+ Add Note")) : existingNote ? /*#__PURE__*/React.createElement("div", {
    className: styles.note
  }, /*#__PURE__*/React.createElement(Typography, {
    weight: "normal",
    as: "span"
  }, "Note:"), ' ', /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    "data-testid": testid && "".concat(testid, "-readonly-note")
  }, existingNote)) : null;
}

export default function AmendmentChanges(props) {
  const {
    items,
    testid,
    autoApprovalDate,
    isUnsaved,
    disableNote,
    disableDiscard,
    disableRequiresApprovalBadges,
    disableApprovalInfoBox,
    disableBorderRadius,
    title = 'Changes',
    onDiscard
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.changes, {
      [styles.disableBorderRadius]: disableBorderRadius
    }),
    "data-testid": testid
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement(Typography, {
    weight: "normal"
  }, title), items.length > 0 && !disableDiscard && /*#__PURE__*/React.createElement(Tooltip, {
    title: "Discard all changes"
  }, /*#__PURE__*/React.createElement(IconButton, {
    type: "button",
    size: "small",
    noPadding: true,
    "data-testid": testid && "".concat(testid, "-discard"),
    onClick: onDiscard
  }, /*#__PURE__*/React.createElement(TrashLiner24, {
    size: 16
  })))), items.length > 0 && /*#__PURE__*/React.createElement("ul", {
    className: styles.items
  }, items.map((_ref, idx) => {
    let {
      text,
      requiresApproval
    } = _ref;
    return /*#__PURE__*/React.createElement(Typography, {
      as: "li",
      className: styles.item,
      key: text
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.itemContent
    }, /*#__PURE__*/React.createElement(Typography, {
      as: "span",
      "data-testid": testid && "".concat(testid, "-").concat(idx)
    }, text), requiresApproval && !disableRequiresApprovalBadges && /*#__PURE__*/React.createElement(Badge, {
      outlined: true,
      rounded: true,
      skin: "warning",
      className: styles.requiresApproval,
      "data-testid": testid && "".concat(testid, "-").concat(idx, "-requires-approval")
    }, "Requires approval")));
  })), !disableNote && /*#__PURE__*/React.createElement(AmendmentNote, props), !disableApprovalInfoBox && !isUnsaved && items.some(item => item.requiresApproval) && /*#__PURE__*/React.createElement(ChangesApprovalInfoBox, {
    className: styles.infoBox,
    testid: testid && "".concat(testid, "-approval-info"),
    autoApprovalDate: autoApprovalDate
  }));
}